module.exports = __webpack_public_path__ + "img/logo.2fb08192.png";